export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'change' },
    ],
    country_id: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'change' },
    ],
};
